// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"67375a68","535":"8e52ee3d","568":"8e52ee3d","624":"8e52ee3d","652":"51561dfc","718":"51561dfc","855":"72caa220","942":"b0ae3b38"}[chunkId] + ".chunk.css";
};